import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { AppConstants } from "@core/constants/app";
import { ApplicationConfigService } from "@core/data/application-config.service";
import dayjs from "dayjs";
import { catchError, take } from "rxjs/operators";
import { of } from "rxjs";
import { Location } from "@angular/common";
import { Generic } from "@core/interfaces/entities/generic";

@Component({
    selector: "app-medicare-application",
    templateUrl: "./medicare-application.component.html",
    styleUrls: ["./medicare-application.component.scss"],
    standalone: false,
})
export class MedicareApplicationComponent {
    public steps = AppConstants.getStepsMapping();
    public materialId: "";
    private applicationIdAttr = null;

    get applicationId(): string | null {
        return this.applicationIdAttr;
    }
    set applicationId(value: string) {
        this.applicationIdAttr = value;
    }
    constructor(
        private applicationConfigService: ApplicationConfigService,
        private location: Location,
        private router: Router,
    ) {
        const stateParam: Generic = this.location.getState();
        this.applicationConfigService
            .getConfig()
            .pipe(
                take(1),
                catchError(() => of(null)),
            )
            .subscribe((data) => {
                if (data?.requestedEffectiveDate && dayjs(data?.requestedEffectiveDate, "YYYY-MM-DD").isValid()) {
                    this.materialId = AppConstants.APPLICATION_MATERIAL_IDS[dayjs(data.requestedEffectiveDate, "YYYY-MM-DD").year()];
                } else {
                    this.materialId = AppConstants.APPLICATION_MATERIAL_IDS[dayjs(stateParam?.requestedEffectiveDate, "YYYY-MM-DD").year()];
                }
                if (data.applicationId) {
                    this.applicationId = data.applicationId;
                }
            });
    }

    isCurrentStep(step: string): boolean {
        return this.router.url.startsWith(step);
    }
}
